const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3c507a8534b1a0cc6dcdc8a45949339d.jpg"
          alt="Technology Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 via-slate-900/50 to-slate-900/70"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="space-y-6">
              <h1 className="text-6xl lg:text-7xl font-bold text-white leading-tight">
                Enterprise IT Solutions
                <br />
                <span className="italic font-light text-cyan-400">That Scale With You</span>
              </h1>
              <p className="text-xl text-gray-300 max-w-2xl leading-relaxed">
                Transform your business with cutting-edge IT consulting, cloud migration, cybersecurity, and managed support services tailored for modern enterprises.
              </p>
              <div className="flex flex-wrap gap-4 pt-4">
                <button
                  onClick={() => window.REACT_APP_NAVIGATE('/contact')}
                  className="px-8 py-4 bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-semibold rounded-lg hover:from-cyan-600 hover:to-blue-700 transition-all shadow-lg hover:shadow-cyan-500/50 whitespace-nowrap cursor-pointer"
                >
                  Schedule Consultation
                </button>
                <button
                  onClick={() => window.REACT_APP_NAVIGATE('/services')}
                  className="px-8 py-4 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-slate-900 transition-all whitespace-nowrap cursor-pointer"
                >
                  View Services
                </button>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 relative">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=3D%20abstract%20illustration%20of%20interconnected%20glowing%20nodes%20and%20data%20streams%20with%20animated%20particles%20floating%20in%20space%20deep%20blue%20cyan%20and%20purple%20gradient%20colors%20representing%20network%20connectivity%20and%20digital%20transformation%20modern%20tech%20visualization%20with%20depth&width=600&height=700&seq=hero-illustration-001&orientation=portrait"
                alt="IT Solutions Visualization"
                className="w-full h-auto rounded-2xl"
              />
              <div className="absolute bottom-8 right-8 space-y-3">
                <div className="bg-white/90 backdrop-blur-sm px-4 py-3 rounded-lg shadow-lg">
                  <p className="text-xs font-semibold text-slate-700">ISO 27001 Certified</p>
                </div>
                <div className="bg-white/90 backdrop-blur-sm px-4 py-3 rounded-lg shadow-lg">
                  <p className="text-xs font-semibold text-slate-700">SOC 2 Compliant</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;